import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useLeaderBoardGetActiveList = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.ILeaderBoardActiveListRequestData) => {
        const response = await send<Types.ILeaderBoardActiveListRequestData, Types.ILeaderBoardActiveListResponseData>({
            ID: 71022,
            responses: [71023, 71024],
            description: 'Get player\'s active leaderboards list',
            ...options
        });

        return response;
    }, [send]);
};
